<template>
    <div class="optionboard-phonetic-vowel">
        <div class="optionboard-phonetic-vowel__feature-type">
            <span class="optionboard-phonetic-vowel__feature-label">DEĞİŞKE ÖZELLİĞİ</span>
            <div class="optionboard-phonetic-vowel__feature-options">
                <BtnOptionPhoneticVowel
                    v-for="variantOption in variantOptions"
                    featureType="variant"
                    :optionSlug="variantOption"
                    :optionText="$t('vowel.variant.' + variantOption)"
                    @click="selectVowelVariant(variantOption)" />
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import BtnOptionPhoneticVowel from '@/components/BtnOptionPhoneticVowel.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            BtnOptionPhoneticVowel,
        },

        props: {
            variantOptions: {
                type: Array,
                default: ['postdorsal', 'predorsal', 'close', 'open', 'near-open'],
            },
        },

        methods: {

            selectVowelVariant(answerDataVowelVariant){
                this.$store.commit('setAnswerDataVowelVariant', answerDataVowelVariant);
            }
        }
    };
</script>

<style scoped src="@/css/components/optionboard-phonetic-vowel.css"></style>